import { SEARCH_URL } from '@stencil/flights-constants';

export const constructThorURL = (searchStringObject, isCombination) => {
  const { query = '' } = searchStringObject;
  if (!query) {
    return '';
  }
  return `${SEARCH_URL}?f=DESKTOP&cu=INR&lob=B2C&src=GI&l=en-IN&cache=n&stream=false&multicity=${query}&package=${
    isCombination ? 'y' : 'n'
  }&new_flow=true&cflags=detail`;
};

export const getSearchParams = searchStringObject => {
  const { query = '' } = searchStringObject;
  if (query) {
    const paramsArray = query.split('-');
    const [
      sources,
      destinations,
      departreDates,
      arrivalDates, // do not remove this
      adult,
      child,
      infant,
      flightClass,
      fareType
    ] = paramsArray;
    return {
      sources: sources.split('|'),
      destinations: destinations.split('|'),
      departureDates: departreDates.split('|'),
      pax: `${adult}-${child}-${infant}`,
      flightClass: flightClass || 'E',
      fareType: fareType || 'R'
    };
  }
};

export const validateSearchParams = searchParams => {
  const { sources, destinations, departureDates } = searchParams;
  if (sources.length === destinations.length && destinations.length === departureDates.length) {
    let hasAllSrc = true;
    let hasAllDest = true;
    let hasAllDates = true;
    sources.forEach(val => {
      if (!val) {
        hasAllSrc = false;
      }
    });
    destinations.forEach(val => {
      if (!val) {
        hasAllDest = false;
      }
    });
    departureDates.forEach(val => {
      if (!val) {
        hasAllDates = false;
      }
    });
    if (hasAllSrc && hasAllDest && hasAllDates) {
      return true;
    }
  }
  return false;
};

export const getIdForRequest = id => {
  const flightKey = Object.keys(id)[0];
  const flightVal = Object.values(id)[0][0];
  const obj = {};
  obj[flightKey] = flightVal;
  return obj;
};

const getSortFunction = {
  'departure|asc': (a, b) => {
    return a.sort_meta.dep_time - b.sort_meta.dep_time;
  },
  'departure|dsc': (a, b) => {
    return b.sort_meta.dep_time - a.sort_meta.dep_time;
  },
  'duration|asc': (a, b) => {
    return a.sort_meta.du - b.sort_meta.du;
  },
  'duration|dsc': (a, b) => {
    return b.sort_meta.du - a.sort_meta.du;
  },
  'arrival|asc': (a, b) => {
    return a.sort_meta.arr_time - b.sort_meta.arr_time;
  },
  'arrival|dsc': (a, b) => {
    return b.sort_meta.arr_time - a.sort_meta.arr_time;
  },
  'price|asc': (a, b) => {
    return a.sort_meta.pr - b.sort_meta.pr;
  },
  'price|dsc': (a, b) => {
    return b.sort_meta.pr - a.sort_meta.pr;
  }
};

export const sortFlights = (list, selectedSort) => {
  const { option, order } = selectedSort;
  const sortFunction = getSortFunction[`${option}|${order}`];
  const sortedList = list.sort(sortFunction);
  return sortedList;
};

export const getFiltersObject = filters => {
  const filtersArr = [];
  const { journey = [] } = filters;
  const journeyLength = journey.length;
  if (!journeyLength) {
    return [];
  }
  for (let i = 0; i < journeyLength; i++) {
    const journeyFilters = journey[i];
    const obj = {};
    journeyFilters.map(journeyFilter => {
      obj[journeyFilter.fi] = Array(journeyFilter.choices.length).fill(0);
    });
    filtersArr.push(obj);
  }
  return filtersArr;
};

export const getRcoms = flights => {
  const rcoms = {};
  if (flights.length) {
    const len = flights.length;
    for (let i = 0; i < len; i++) {
      const flight = flights[i];
      const id = flight.id;
      const keys = Object.keys(id);
      const values = Object.values(id);
      rcoms[keys[0]] = values[0][0];
    }
  }
  return rcoms;
};
